import { render, staticRenderFns } from "./tabbar-item.vue?vue&type=template&id=023e437a&"
import script from "./tabbar-item.vue?vue&type=script&lang=js&"
export * from "./tabbar-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports